import {
  Button,
  Label,
  RadioInput,
  TextInput,
  Unform,
  AddObservation,
  CheckboxComp,
} from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { Flex, Box, Stack, Spacer } from '@chakra-ui/react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { getCommonProps } from 'utils/CommonPropperties';

import { evaluationCtx } from '../../index';
import Evaluation from 'models/Forms/Evaluation';
import { checkPermission } from 'utils/authentication';

interface IProps extends BodyProps {}

const DataNatureComponent: React.FC<IProps> = ({ index, functionCallback, submit, completed }) => {
  const ctx = useContext(evaluationCtx);
  const { load, setIsLoad } = useContext(evaluationCtx);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [boxes, setBoxes] = React.useState<string[]>(
    (ctx.isDetails ? ctx.data.sensitivePersonalDataSources?.split(/\s*,\s*/) : undefined) || [
      'Não',
    ],
  );
  const formRef = useRef<FormHandles>(null);

  const commonProps = useMemo(
    () => ({
      ...getCommonProps(!!ctx.isDetails),
      defaultBgColor: 'primary',
    }),
    [ctx.isDetails],
  );

  useEffect(() => {
    ctx.handlePayload(prevState => ({
      ...prevState,
      sensitivePersonalDataSources: boxes.toString(),
    }));

    if (boxes.length === 0 || boxes.includes('Não')) {
      formRef.current?.setFieldValue(
        'processingOfSensitivePersonalData',
        'O projeto não envolve o tratamento de dados sensíveis',
      );
    } else {
      formRef.current?.setFieldValue(
        'processingOfSensitivePersonalData',
        'O projeto envolve o tratamento de dados sensíveis',
      );
    }
  }, [boxes]);

  function boxClicked(box: string) {
    if (boxes.includes(box)) {
      setBoxes(
        boxes.filter(function (i) {
          return i !== box;
        }),
      );
    } else {
      if (box === 'Não') {
        setBoxes([box]);
      } else {
        if (boxes.includes('Não')) {
          setBoxes([box]);
        } else {
          setBoxes([...boxes, box]);
        }
      }
    }
  }

  const handleSubmit = useCallback<SubmitHandler<Evaluation>>(
    async data => {
      const { processingOfSensitivePersonalData } = data;

      setLoading(true);
      setIsLoad(load);
      if (submit) {
        const resp = await submit({ processingOfSensitivePersonalData }, '2 - Natureza dos dados');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [functionCallback, submit],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        formRef={formRef}
        onSubmit={handleSubmit}
        // validationSchema={dataNatureValidationSchema}
        initialData={ctx.data}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Label>O projeto envolve o tratamento de alguma dessas categorias de dados?</Label>
            <Flex mb="22px" mt="23px">
              {' '}
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Raça')}
                  isChecked={boxes.includes('Raça')}
                >
                  Raça
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Etnia')}
                  isChecked={boxes.includes('Etnia')}
                >
                  Etnia
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Religião')}
                  isChecked={boxes.includes('Religião')}
                >
                  Religião
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Opnião política')}
                  isChecked={boxes.includes('Opnião política')}
                >
                  Opnião política
                </CheckboxComp>
              </Flex>
              <Spacer />
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Convicção filosófica')}
                  isChecked={boxes.includes('Convicção filosófica')}
                >
                  Convicção filosófica
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Filiação sindical ou partidária')}
                  isChecked={boxes.includes('Filiação sindical ou partidária')}
                >
                  Filiação sindical ou partidária
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Dados de saúde')}
                  isChecked={boxes.includes('Dados de saúde')}
                >
                  Dados de saúde
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Dados referentes à vida sexual ou orientação sexual')}
                  isChecked={boxes.includes('Dados referentes à vida sexual ou orientação sexual')}
                >
                  Dados referentes à vida sexual ou orientação sexual
                </CheckboxComp>
              </Flex>
              <Spacer />
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Dados genéticos')}
                  isChecked={boxes.includes('Dados genéticos')}
                >
                  Dados genéticos
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked('Dados biométricos')}
                  isChecked={boxes.includes('Dados biométricos')}
                >
                  Dados biométricos
                </CheckboxComp>
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => {
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      sensitivePersonalDataSources: 'Não',
                    }));
                    boxClicked('Não');
                  }}
                  isChecked={boxes.includes('Não')}
                >
                  Não
                </CheckboxComp>
              </Flex>
            </Flex>
            <Box>
              <TextInput
                {...commonProps}
                disabled={true}
                name="processingOfSensitivePersonalData"
              />
              <AddObservation
                // isDetail={!ctx.isDetails}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="20px"
                obsValue={ctx.data.jsonCustomObsObj.processingOfSensitivePersonalData}
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      processingOfSensitivePersonalData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            <Box>
              <Label>
                O projeto tem como foco o tratamento de dados pessoais de pessoas que merecem
                especial atenção, como idosos, crianças e adolescentes, pessoas portadoras de
                deficiência, etc?
              </Label>
              <Box mt="8px">
                <RadioInput
                  label="Sim"
                  name="focusProcessingPersonalDataOfVulnerable"
                  value={ctx.data.focusProcessingPersonalDataOfVulnerable}
                  onChange={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      focusProcessingPersonalDataOfVulnerable: e,
                    }))
                  }
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder={'Observações (opcional)'}
                  obsValue={ctx.data.jsonCustomObsObj.focusProcessingPersonalDataOfVulnerable}
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        focusProcessingPersonalDataOfVulnerable: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            <Box mt="28px">
              <Label>O projeto envolve o tratamento de registros criminais?</Label>
              <Box mt="8px">
                <RadioInput
                  label="Sim"
                  name="handlingCriminalRecords"
                  value={ctx.data.handlingCriminalRecords}
                  onChange={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      handlingCriminalRecords: e,
                    }))
                  }
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder={'Observações (opcional)'}
                  obsValue={ctx.data.jsonCustomObsObj.handlingCriminalRecords}
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        handlingCriminalRecords: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Label>O projeto envolve o tratamento de alguma dessas categorias de dados?</Label>
            <Flex mb="22px" mt="23px">
              {' '}
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Raça')}
                  isChecked={boxes.includes('Raça')}
                >
                  Raça
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Etnia')}
                  isChecked={boxes.includes('Etnia')}
                >
                  Etnia
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Religião')}
                  isChecked={boxes.includes('Religião')}
                >
                  Religião
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Opnião política')}
                  isChecked={boxes.includes('Opnião política')}
                >
                  Opnião política
                </CheckboxComp>
              </Flex>
              <Spacer />
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Convicção filosófica')}
                  isChecked={boxes.includes('Convicção filosófica')}
                >
                  Convicção filosófica
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Filiação sindical ou partidária')}
                  isChecked={boxes.includes('Filiação sindical ou partidária')}
                >
                  Filiação sindical ou partidária
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dados de saúde')}
                  isChecked={boxes.includes('Dados de saúde')}
                >
                  Dados de saúde
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dados referentes à vida sexual ou orientação sexual')}
                  isChecked={boxes.includes('Dados referentes à vida sexual ou orientação sexual')}
                >
                  Dados referentes à vida sexual ou orientação sexual
                </CheckboxComp>
              </Flex>
              <Spacer />
              <Flex flexDirection="column" maxWidth="33%">
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dados genéticos')}
                  isChecked={boxes.includes('Dados genéticos')}
                >
                  Dados genéticos
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked('Dados biométricos')}
                  isChecked={boxes.includes('Dados biométricos')}
                >
                  Dados biométricos
                </CheckboxComp>
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => {
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      sensitivePersonalDataSources: 'Não',
                    }));
                    boxClicked('Não');
                  }}
                  isChecked={boxes.includes('Não')}
                >
                  Não
                </CheckboxComp>
              </Flex>
            </Flex>
            <Box>
              <TextInput
                isDisabled={completed}
                disabled={true}
                name="processingOfSensitivePersonalData"
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="20px"
                obsValue={ctx.data.jsonCustomObsObj.processingOfSensitivePersonalData}
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      processingOfSensitivePersonalData: e.target.value,
                    },
                  }))
                }
              />
            </Box>
            <Box>
              <Label>
                O projeto tem como foco o tratamento de dados pessoais de pessoas que merecem
                especial atenção, como idosos, crianças e adolescentes, pessoas portadoras de
                deficiência etc?
              </Label>
              <Box mt="8px">
                <RadioInput
                  isDisabled={completed}
                  label="Sim"
                  name="focusProcessingPersonalDataOfVulnerable"
                  value={ctx.data.focusProcessingPersonalDataOfVulnerable}
                  onChange={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      focusProcessingPersonalDataOfVulnerable: e,
                    }))
                  }
                />
                <AddObservation
                  isDetail={completed}
                  placeholder={'Observações (opcional)'}
                  obsValue={ctx.data.jsonCustomObsObj.focusProcessingPersonalDataOfVulnerable}
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        focusProcessingPersonalDataOfVulnerable: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            <Box mt="28px">
              <Label>O projeto envolve o tratamento de registros criminais?</Label>
              <Box mt="8px">
                <RadioInput
                  isDisabled={completed}
                  label="Sim"
                  name="handlingCriminalRecords"
                  value={ctx.data.handlingCriminalRecords}
                  onChange={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      handlingCriminalRecords: e,
                    }))
                  }
                />
                <AddObservation
                  isDetail={completed}
                  placeholder={'Observações (opcional)'}
                  obsValue={ctx.data.jsonCustomObsObj.handlingCriminalRecords}
                  onChangeEvent={e =>
                    ctx.handlePayload(prevState => ({
                      ...prevState,
                      jsonCustomObsObj: {
                        ...prevState.jsonCustomObsObj,
                        handlingCriminalRecords: e.target.value,
                      },
                    }))
                  }
                />
              </Box>
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const DataNature = memo(DataNatureComponent);
